require('./newsletter');
require('./cookies');
require('./contact');
require('./dots');
require('./slider');
require('./offer-request-lead-widget');
require('./products');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js